import styled from "styled-components";
import Tag from "./Tag";

const TypeTag = styled(Tag)`
    background-color: #ab0033;
`;

export default TypeTag;